<template>
  <div>
    <toolbar-loader v-if="loading"></toolbar-loader>
    <feedback-card
      class="mb-3"
      v-for="feedback in feedbacks" :key="feedback.id"
      :feedback="feedback">
    </feedback-card>

    <div class="text-xs-center pb-3" v-if="pagination && pagination.total">
      <v-pagination
        :disabled="loading"
        :value="pagination.page"
        @input="value => changePage(value)"
        :length="Math.ceil(pagination.total / pagination.perPage)">
      </v-pagination>
    </div>

    <empty-state v-if="(!pagination || !pagination.total) && !loading">
      {{ $t('pages.feedbacks.empty') }} {{ $t(`pages.feedbacks.${status}`) }}
    </empty-state>
  </div>
</template>

<script>
  import pagination from '@/mixins/pagination'
  import ToolbarLoader from '@/components/ToolbarLoader.vue'
  import FeedbackCard from '@/components/FeedbackCard.vue'
  import EmptyState from '@/components/EmptyState.vue'
  export default {
    components: {
      ToolbarLoader,
      FeedbackCard,
      EmptyState
    },
    mixins: [pagination('skiliko/feedbacks')],
    props: {
      page: {
        type: Number,
        default: 1
      },
      status: {
        type: String,
        default: 'pending'
      },
      url: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        filter: {
          page: this.page,
          status: this.status
        }
      }
    },
    watch: {
      page () { this.filter = { ...this.filter, page: this.page } },
      status () { this.filter = { ...this.filter, status: this.status, page: 1 } }
    },
    methods: {
      urlParams (filter) {
        return {
          page: filter.page
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Feedbacks.vue